export default __webpack_public_path__ + "static/Fall5-54bff848e7160d2bca28616fb2e2d822.mp3";